import { firebaseApp } from "../firebase";
import { getStorage, getMetadata, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';

const uploadModule = {
  namespaced: true,
  state: {
    // Agora 'uploads' é um array de objetos, cada um representando um upload
    uploads: [], // { id, name, uploading, progress, downloadURL, error }
  },
  mutations: {
    ADD_UPLOAD(state, { id, name, file }) {
      state.uploads.push({
        id,
        name,
        file, // Opcional, mas útil para referência
        uploading: true,
        progress: 0,
        downloadURL: null,
        error: null,
      });
    },
    UPDATE_UPLOAD_PROGRESS(state, { id, progress }) {
      const upload = state.uploads.find(u => u.id === id);
      if (upload) {
        upload.progress = progress;
      }
    },
    SET_UPLOAD_SUCCESS(state, { id, downloadURL }) {
      const upload = state.uploads.find(u => u.id === id);
      if (upload) {
        upload.downloadURL = downloadURL;
        upload.uploading = false;
        upload.progress = 100;
      }
    },
    SET_UPLOAD_ERROR(state, { id, error }) {
      const upload = state.uploads.find(u => u.id === id);
      if (upload) {
        upload.error = error;
        upload.uploading = false;
        upload.progress = null; // Ou deixar no último valor
      }
    },
    RESET_ALL_UPLOADS(state) {
      state.uploads = []; // Limpa todos os status de upload
    },
  },
  actions: {
    async uploadFile({ commit }, { id, file, path }) {
      console.log(id, file, path)
      const storage = getStorage(firebaseApp)
      // Adiciona o novo upload ao estado
      commit('ADD_UPLOAD', { id, name: file.name, file });

      try {
        const storageRef = ref(storage, path);
        const uploadTask = uploadBytesResumable(storageRef, file)

        uploadTask.on('state_changed',
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            commit('UPDATE_UPLOAD_PROGRESS', { id, progress });
          },
          (error) => {
            console.error(`Erro no upload para ${file.name}:`, error);
            commit('SET_UPLOAD_ERROR', { id, error: error.message });
          },
          async () => {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            commit('SET_UPLOAD_SUCCESS', { id, downloadURL });
          }
        );
      } catch (e) {
        console.error(`Falha ao iniciar upload para ${file.name}:`, e);
        commit('SET_UPLOAD_ERROR', { id, error: e.message });
      }
    },
    async getBucketMetadata() {
      const storage = getStorage(); // inicializa o Firebase Storage
      const fileRef = ref(storage, 'images/ImwvcZtgXVVvGapin0IulzBTQHk1/Milano09.jpg'); // caminho do arquivo
      try {
        const metadata = await getMetadata(fileRef); // obtém os metadados
        console.log(JSON.stringify(metadata, null, 2));
      } catch (error) {
        console.error('Erro ao obter metadados:', error);
      }
    }
  }
};

export default uploadModule;
